import 'Variables';

import { q, qq, ww } from 'bobjoll/ts/library/dom';
import { storeUrl } from 'CommonFI/urls.helper';
import { cookie } from 'Library/cookie';
import { EventTracker } from 'Library/eventTacker';
import { Swiper } from 'Library/swiper';
import getXHR from 'Partials/xhr';
import { initializeModalUpgrade, PricingFrequency } from 'Project/ts/pages/pricing/modalUpgrade';
import User from 'Project/ts/pods/user/main';

import { PlanElementData, sendAddToCartG4Event, sendViewItemListEvent } from './ga4';

require('Project/ts/templates/helpers');

const SwiperOptions = {
    maxWidth: 400,
    minWidth: 280,
    selector: '.pricing__swiper',
    navigation: {
        elementPrev: '.swiper__button--prev',
        elementNext: '.swiper__button--next',
        disabledClass: 'disabled',
    },
};

qq('.pricing__swiper').forEach(element => new Swiper(SwiperOptions, element));

declare const modalData: PricingUpgradeData | undefined;
const buttonGoPremium = q('.go-premium');
const elementPlansPricing = q('.pricing__plans');
const planButtons = qq('.plan-button');
const showPricesDelay = 3000;

type PlanContainerHTMLElement = HTMLLinkElement & { dataset: PlanElementData };

const eventHandlerClickPlanButton = async function(this: PlanContainerHTMLElement, event: Event) {
    let loader = q('#loader');
    if (loader) {
        loader.style.display = 'block';
    }
    event.preventDefault();
    const frequency = this.dataset.frequency as PricingFrequency;
    const code = this.dataset.code as string;
    const coupon = this.dataset.coupon as string;
    const frequencyUrl = `${('month' as PricingFrequency) === frequency ? 'monthly' : 'year'}`;
    const price = this.dataset.price as string;
    const priceNoTaxes = this.dataset.priceNoTaxes as string;
    const priceNoDiscount = this.dataset.priceNoDiscount as string;
    const priceNoDiscountNoTaxes = this.dataset.priceNoDiscountNoTaxes as string;
    const taxesAmountNoDiscount = this.dataset.taxesAmountNoDiscount as string;
    let taxesPercentage = this.dataset.taxesPercentage as string;
    const taxesAmount = this.dataset.taxesAmount as string;
    const priceFrequency = this.dataset.priceFrequency as string;
    const isLogged = gr?.auth.logged || false;
    const currency = this.dataset.currency as string;
    let url =
        this.getAttribute('href') ||
        `${BASE_URL}profile/preagreement/payment/?opt=${frequencyUrl}&landing=getstarted&product_code=${code}`;
    if (taxesPercentage) {
        taxesPercentage += '%';
    }
    if (coupon) {
        url += '&coupon=' + encodeURI(coupon);
    }

    /** Evento GA **/
    let trackArgs = this.dataset.trackArguments
        ? this.dataset.trackArguments.split(',').map(item => item.trim())
        : null;
    if (trackArgs && trackArgs.length > 0) {
        EventTracker.send(...trackArgs);
    }

    sendAddToCartG4Event(this.dataset);

    if (User.isLogged()) {
        if (!isLogged) {
            window.location.reload();
        } else {
            if ('undefined' !== typeof modalData) {
                initializeModalUpgrade(modalData, {
                    coupon,
                    frequency,
                    price,
                    priceFrequency,
                    currency,
                    priceNoTaxes,
                    taxesPercentage,
                    taxesAmount,
                    priceNoDiscount,
                    priceNoDiscountNoTaxes,
                    taxesAmountNoDiscount,
                });
            } else {
                window.location.href = url;
            }
        }
    } else {
        storeUrl(url);
        window.location.href = GOOGLE_IDP_URL_LOGIN;
    }
};

if (buttonGoPremium && elementPlansPricing) {
    buttonGoPremium.addEventListener('click', function() {
        try {
            elementPlansPricing.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'center',
            });
        } catch (error) {
            //Scroll.to(elementPlansPricing, 500, 'linear');
        }
    });
}

const getAvailablePlansData = (): PlanElementData[] => {
    const containerPlans = document.querySelectorAll('.plans a') as NodeListOf<PlanContainerHTMLElement>;
    const plansData: PlanElementData[] = [];

    containerPlans.forEach(item => plansData.push(item.dataset));

    return plansData;
};

window.addEventListener('load', () => {
    if (planButtons) {
        planButtons.forEach(plan => {
            plan.addEventListener('click', eventHandlerClickPlanButton);
        });
    }

    const plansData = getAvailablePlansData();

    sendViewItemListEvent(plansData);
});

qq('.tooltip').forEach(tooltipElement => {
    tooltipElement.addEventListener('mouseenter', () => {
        const windowWidth = document.body.clientWidth;
        const containerElement = q('.tooltip__container', tooltipElement);
        if (containerElement) {
            containerElement.removeAttribute('style');
            const { left, width } = containerElement.getBoundingClientRect();
            const offsetX = left + width;
            if (offsetX > windowWidth) {
                containerElement.style.marginLeft = `${windowWidth - offsetX - 10}px`;
            }
        }
    });
});

if (!cookie.getItem('visit-plans-pricing')) {
    cookie.setItem('visit-plans-pricing', '1', {
        expires: new Date(new Date().getTime() + 30 * 24 * 60 * 60 * 1000),
    });
}

localStorage.setItem('item_list_name', 'pricing');

export const showAsyncPrices = () => {
    qq('.async-hide').forEach(element => {
        element.style.visibility = 'visible';
    });
};

export const fetchAndUpdateProductPrices = () => {
    qq('.async-hide').forEach(element => {
        element.style.visibility = 'hidden';
    });
    setTimeout(showAsyncPrices, showPricesDelay);

    let url = `${BASE_URL}ajax/pricing/get-product-prices`;
    let urlParams = new URL(window.location.href);
    if (urlParams.searchParams.get('coupon') != null) {
        url += '?coupon=' + urlParams.searchParams.get('coupon');
    }

    getXHR(url, {
        method: 'GET',
        withCredentials: true,
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        },
    })
        .then((data: ProductPrices) => {
            if (data.success === true) {
                let annualPricePerMonthElement = document.getElementById('price-annual-per-month') as HTMLElement;
                updatePriceContent(annualPricePerMonthElement, data.yearlyPricePerMonth);
                let annualPriceWhitoutDiscountElement = document.getElementById(
                    'price-annual-without-discount',
                ) as HTMLElement;
                updatePriceContent(annualPriceWhitoutDiscountElement, data.yearlyPriceNoDiscount);
                let annualPriceInfo = document.getElementById('price-annual') as HTMLElement;
                updatePriceContent(annualPriceInfo, data.yearlyPrice);

                let monthlyPricePerMonthElement = document.getElementById('price-monthly-per-month') as HTMLElement;
                updatePriceContent(monthlyPricePerMonthElement, data.monthlyPrice);
                let monthlyPriceWhitoutDiscountElement = document.getElementById(
                    'price-monthly-without-discount',
                ) as HTMLElement;
                updatePriceContent(monthlyPriceWhitoutDiscountElement, data.monthlyPriceNoDiscount);
                let monthlyPriceInfo = document.getElementById('price-monthly') as HTMLElement;
                updatePriceContent(monthlyPriceInfo, data.monthlyPrice);

                let premiumPlusAnnualPricePerMonthElement = document.getElementById(
                    'price-pp-annual-per-month',
                ) as HTMLElement;
                updatePriceContent(premiumPlusAnnualPricePerMonthElement, data.premiumPlus.yearlyPricePerMonth);
                let premiumPlusAnnualPriceWhitoutDiscountElement = document.getElementById(
                    'price-pp-annual-without-discount',
                ) as HTMLElement;
                if (!premiumPlusAnnualPriceWhitoutDiscountElement && data.premiumPlus.applyDiscountYearly) {
                    premiumPlusAnnualPricePerMonthElement.insertAdjacentHTML(
                        'beforebegin',
                        '<span id="price-pp-annual-without-discount" class="price-original async-hide strike font-lg text__gray--4 pd-right-lv2 eur" style="visibility: visible;">\
                        <span class="integer-part"></span><span class="price-original__qty"><span class="decimal-part"></span></span>\
                        <span class="currency-part"></span>\
                        </span>',
                    );
                    premiumPlusAnnualPriceWhitoutDiscountElement = document.getElementById(
                        'price-pp-annual-without-discount',
                    ) as HTMLElement;
                }

                updatePriceContent(
                    premiumPlusAnnualPriceWhitoutDiscountElement,
                    data.premiumPlus.yearlyPriceNoDiscount,
                );
                let premiumPlusPriceInfo = document.getElementById('price-pp-annual') as HTMLElement;
                updatePriceContent(premiumPlusPriceInfo, data.premiumPlus.yearlyPrice);

                showAsyncPrices();
            } else {
                console.error("Can't retrieve data: " + data.msg);
            }
        })
        .catch(err => {
            console.error("Can't retrieve data: " + err);
        });
};
ww.fetchAndUpdateProductPrices = fetchAndUpdateProductPrices;

const updatePriceContent = (element: HTMLElement, price: Price) => {
    if (element) {
        if (q('.premium__plans')) {
            let integerElement = q('.integer-part', element);
            integerElement ? (integerElement.innerHTML = price.integer) : '';
            let decimalElement = q('.decimal-part', element);
            decimalElement ? (decimalElement.innerHTML = `${price.decimalSeparator}${price.decimal}`) : '';
            let currencyElement = q('.currency-part', element);
            currencyElement ? (currencyElement.innerHTML = price.currency) : '';
        } else {
            element.innerHTML = buildPrice(price);
        }
    }
};

const buildPrice = (price: Price) => {
    return `${price.integer}${price.decimalSeparator}${price.decimal} ${price.currency}`;
};

export interface PricingUpgradeData {
    hasProrates: string;
    payment: string;
    paymentMethod: 'stripe' | 'paypal';
    hasAnotherPremiumSubscription: boolean;
}

interface Price {
    currency: string;
    decimal: string;
    decimalSeparator: string;
    integer: string;
}

interface ProductPrices {
    success: boolean;
    msg?: string;
    applyDiscountMonthly?: boolean;
    applyDiscountYearly?: boolean;
    monthlyPrice: Price;
    monthlyPriceNoDiscount: Price;
    yearlyPrice: Price;
    yearlyPriceNoDiscount: Price;
    yearlyPricePerMonth: Price;
    premiumPlus: {
        applyDiscountMonthly?: boolean;
        applyDiscountYearly?: boolean;
        monthlyPrice: Price;
        monthlyPriceNoDiscount: Price;
        yearlyPricePerMonth: Price;
        yearlyPrice: Price;
        yearlyPriceNoDiscount: Price;
    };
}
